<template>
  <div>
    <div class="tw-px-4">
      <button
        class="tw-block tw-w-full"
        :data-test-id="testId"
        @click="toggle()"
      >
        <div class="tw-flex tw-items-center tw-justify-between">
          <slot name="summary" />
          <div>
            <ClIconTablerChevronDown
              class="tw-transition-transform"
              :class="isOpen ? 'tw-rotate-180' : 'tw-rotate-0'"
            />
          </div>
        </div>
      </button>
      <div v-if="isOpen">
        <slot name="details" />
      </div>
    </div>
    <cl-hr size="md" />
  </div>
</template>

<script lang="ts" setup>
import { useToggle } from "@vueuse/core";
import { ClIconTablerChevronDown } from "../icons";
import clHr from "../hr/cl-hr.vue";

export interface AccordionProps {
  testId?: string;
  isOpenDefault?: boolean;
}

const props = withDefaults(defineProps<AccordionProps>(), {
  testId: "cl-accordion-toggle-btn",
  isOpenDefault: false,
});

const [isOpen, toggle] = useToggle(props.isOpenDefault);
</script>
